import React from 'react'

import Community from '../components/Community'
import SEO from '../components/SEO'

const CommunityPage: React.FC = () => (
  <>
    <SEO title="Community" />
    <Community />
  </>
)

export default CommunityPage
